// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___TRLt8","portalPermissionsContainer":"styles__portalPermissionsContainer___2SkIt","portalPermissionsHeader":"styles__portalPermissionsHeader___3i1jJ"};